//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MZLoading',
  props: {},
  data () {
    return {
      icon: '',
      img: '',
      message: ''
    }
  },
  mounted () {
    console.log(this.icon, this.img, this.message)
  }
}



// WEBPACK FOOTER //
// ./node_modules/_mengzhua-ui@1.1.4@mengzhua-ui/components/loading/index.vue